import { createActionType } from "Common/namespaceUtils/namespaceRedux";
import { FULL_NAMESPACE } from "../constants";
export default {
    SET_IS_EXPANDED: createActionType(FULL_NAMESPACE, "SET_IS_EXPANDED")
};
